import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs';
import { CommonService } from '../../common.service';
import { NgxSpinnerService } from "ngx-spinner";
import { DatePipe } from '@angular/common';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import * as XLSX from 'xlsx';
import { CommonVariablesService } from '../../common-variables.service';

@Component({
  selector: 'app-sanctioncountryreport',
  templateUrl: './sanctioncountryreport.component.html',
})
export class SanctioncountryreportComponent implements OnInit 
{
  sanctionCountryReportForm: FormGroup;
  systemDate:any;
  getFromDate:any;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any;
  displaySanctionCountryReport:any=[];
  submitted = false;
  countryList:any=[];
  dropdownSettings: IDropdownSettings = {};
  getsystemDate:any;
  fromDate:any;
  toDate:any;

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private commonVariablesService: CommonVariablesService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
	  window.localStorage.setItem('pageName','');
    $("#divSanctionCountryReport").hide();
    $("#btnSanctionCountryReportExcelDownload").hide();
    this.sanctionCountryReportForm = this.formBuilder.group({
      selectFromDate: ['',Validators.required],
      selectToDate: ['',Validators.required],
      selectCountry:[this.countryList,Validators.required],
      branchLocation:['']
    });

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'country_id',
      textField: 'country_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 5,
      allowSearchFilter: true
    };

    this.dtOptions = {
      dom: 'frtip',
      "pageLength": 50
    };

    this.getsystemDate=new Date();
    let getDate =new Date(this.getsystemDate);
    getDate.setMonth(getDate.getMonth()-1);
    
    this.getFromDate=getDate;
    
    /*this.sanctionCountryReportForm.patchValue({
      selectFromDate: this.getFromDate,
      selectToDate: this.getsystemDate,
      });*/

    this.systemDate=this.datePipe.transform(this.getsystemDate,'yyyy-MM-dd');

    this.loadCountryList();
   
  }

  get f() { return this.sanctionCountryReportForm.controls; }

  /*
  * Created By : Keerthana
  * Description : This function will fetch the country list.
  *********************************************/

  async loadCountryList()
  {
    let fetchCountryUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/fetchall/country_master';
    let fetchCountryData = await this.commonService.httpGetMethod(fetchCountryUrl, 'application/x-www-form-urlencoded', true, '', 'Sanction Country Report');
    this.countryList = [];
    if(fetchCountryData.status == 0)
    {
      for (var i = 0; i < fetchCountryData.data.length; i++)
      {
        if(fetchCountryData.data[i].referral !="Approved" && fetchCountryData.data[i].status == 0)
        {
          this.countryList.push({ 'country_id': fetchCountryData.data[i].country_id, 'country_name': fetchCountryData.data[i].country_name });
        }
      }
    }
    this.sanctionCountryReportForm.patchValue({
      selectCountry: this.countryList,
      
      });
  }

  

 /*
 * Created By : Keerthana
 * Description : This function will submit the data.
 *********************************************/
 
 async submitDate()
 {
  if (this.sanctionCountryReportForm.invalid)
  {
    this.submitted = true;
    return;
  }
  else
  {
    
    this.fromDate=this.datePipe.transform(this.sanctionCountryReportForm.value.selectFromDate);
	  this.toDate=this.datePipe.transform(this.sanctionCountryReportForm.value.selectToDate);
    
    if(new Date(this.toDate)<new Date(this.fromDate))
    {
      this.commonService.errorsmsg("From date should be less than to date","Error");
    }
    /*else if(new Date(this.toDate)>new Date(this.systemDate))
    {
      this.commonService.errorsmsg("To date should not be greater than system date","Error");
    }*/
   else
   {
     this.spinner.show();
     
     let countryListValue='';
     
    for(var i=0;i<this.sanctionCountryReportForm.value.selectCountry.length;i++)
    {
      if(i<this.sanctionCountryReportForm.value.selectCountry.length-1)
      {
        countryListValue+=this.sanctionCountryReportForm.value.selectCountry[i].country_name+'~'
      }
      else
      {
        countryListValue+=this.sanctionCountryReportForm.value.selectCountry[i].country_name 
      }
      
    }
    $('#searchCertificateNo,#searchPolicyNo,#searchBranchLocation,#searchInsuredName,#searchProducerName,#searchVoyage,#searchModeOfShipment,#searchFromCountry,#searchToCountry,#searchFromCity,#searchToCity,#searchTotalSumInsuredIn,#searchSubjectMatterInsured,#searchExpectedDateOfShipment,#searchActionBy,#searchReferredOn,#searchActionOn').val('');
    let table = $('#sanctionCountryReportDataTable').DataTable();
     table.destroy();
    let param = new HttpParams()
    .set('from_date', this.datePipe.transform(this.fromDate,'yyyy-MM-dd'))
    .set('to_date', this.datePipe.transform(this.toDate,'yyyy-MM-dd'))
    .set('country', countryListValue || '')
    .set('branch_location',  this.sanctionCountryReportForm.value.branchLocation || '')
    
     let submitUrl = this.commonVariablesService.baseURL + 'api/v1/marine_report/fetch_sanction_country';
     
     let submitData = await this.commonService.httpGetMethod(submitUrl,'',true, param, 'Sanction Country Report');
     
     this.displaySanctionCountryReport=[];
     if (submitData.status == 0)
     {
      if(submitData.data.length>0)
      {
       for (var idx = 0; idx < submitData.data.length; idx++)
       {
         this.displaySanctionCountryReport.push(submitData.data[idx]);
       }
      }
     
     }
     else if (submitData.status !=-114)
     {
       this.commonService.errorsmsg('Fetch Error: ' +submitData.txt,'Error');
     }
     
     this.dtTrigger.next();
     $("#divSanctionCountryReport").show();
     $("#btnSanctionCountryReportExcelDownload").show();
   }
 }
}

  /*
  * Created By : Keerthana
  * Description : This function is used to download the excel file.
  *********************************************/
  
 exportExcel()
 {
  let countryListExcelValue='';
  
 for(var i=0;i<this.sanctionCountryReportForm.value.selectCountry.length;i++)
 {
   if(i<this.sanctionCountryReportForm.value.selectCountry.length-1)
   {
    countryListExcelValue+=this.sanctionCountryReportForm.value.selectCountry[i].country_name+','
   }
   else
   {
    countryListExcelValue+=this.sanctionCountryReportForm.value.selectCountry[i].country_name 
   }
   
 }
   var tmpArray=[];
   var tmpObj={};
   
   if(this.displaySanctionCountryReport.length>0)
   {
     for(var idx=0;idx<this.displaySanctionCountryReport.length;idx++)
     {
      tmpObj={};
        tmpObj['certificate_no']=this.displaySanctionCountryReport[idx].certificate_no;
        tmpObj['policy_no']=this.displaySanctionCountryReport[idx].policy_no;
        tmpObj['branch_location']=this.displaySanctionCountryReport[idx].branch_location;
        tmpObj['insured_name']=this.displaySanctionCountryReport[idx].insured_name;
        tmpObj['producer_name']=this.displaySanctionCountryReport[idx].producer_name;
        tmpObj['voyage_name']=this.displaySanctionCountryReport[idx].voyage_name;
        tmpObj['mode_of_shipment']=this.displaySanctionCountryReport[idx].mode_of_shipment;
        tmpObj['from_country']=this.displaySanctionCountryReport[idx].from_country;
        tmpObj['to_country']=this.displaySanctionCountryReport[idx].to_country;
        tmpObj['from_city']=this.displaySanctionCountryReport[idx].from_city;
        tmpObj['to_city']=this.displaySanctionCountryReport[idx].to_city;
        tmpObj['total_sum_insured']=this.displaySanctionCountryReport[idx].total_sum_insured;
        tmpObj['subject_matter_issued']=this.displaySanctionCountryReport[idx].subject_matter_issued;
        tmpObj['expected_date_of_shipment']=this.displaySanctionCountryReport[idx].expected_date_of_shipment;
        tmpObj['actioned_by']=this.displaySanctionCountryReport[idx].actioned_by;
        tmpObj['reffered_on']=this.displaySanctionCountryReport[idx].referral_on;
        tmpObj['actioned_on']=this.displaySanctionCountryReport[idx].actioned_on;
        tmpArray.push(tmpObj)
     }
     var datajson= { datajson1: tmpArray };

     var Heading = [
       [],
       ["Sanction Country Report"],
       [],
       ["From Date" , this.datePipe.transform(this.sanctionCountryReportForm.value.selectFromDate,'dd-MM-yyyy') || ''],
       ["To Date" , this.datePipe.transform(this.sanctionCountryReportForm.value.selectToDate,'dd-MM-yyyy') || ''],
       ["Country" , countryListExcelValue || ''],
       ["Branch Location" , this.sanctionCountryReportForm.value.branchLocation || ''],
       [],
       ["Certificate No / Draft No","Policy No","Branch Location","Insured Name","Producer Name","Voyage","Mode of Shipment","From Country","To Country","From City","To City","Total Sum Insured in","Subject Matter Insured","Expected date of shipment","Actioned by","Referred on","Actioned on"]
     ];

     const merge = [
         { s: { r: 0, c: 0 }, e: { r: 0, c: 16 } },
         { s: { r: 1, c: 0 }, e: { r: 1, c: 16 } },
         { s: { r: 2, c: 0 }, e: { r: 2, c: 16 } },
         { s: { r: 3, c: 0 }, e: { r: 3, c: 16 } },
         { s: { r: 8, c: 0 }, e: { r: 8, c: 16 } }
     ];
     
     var wscols = [];
     //let cell;
     for (let index = 0; index < Heading[8].length; index++) 
     {
         wscols.push({ wch: 25 });  // Common column width
     }
     var ws = XLSX.utils.json_to_sheet(Heading);
     ws['!cols'] = wscols;
     ws["!merges"] = merge;
     ws["A1"] = {
         "t": 's',
         /* "v": 'TATA MARINE', */
         "s": { font: { size: 20, bold: true, color: "#e012e0", style: "text-align:center"} }
     };
     XLSX.utils.sheet_add_json(ws, datajson.datajson1, {
         header: ["certificate_no","policy_no","branch_location","insured_name","producer_name","voyage_name","mode_of_shipment","from_country","to_country","from_city","to_city","total_sum_insured","subject_matter_issued","expected_date_of_shipment","actioned_by","reffered_on","actioned_on"],
         skipHeader: true,
         origin: -1
     });
     // var alphabets = [''];
     var wb = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, "Sanction Country Report");
     XLSX.writeFile(wb, 'Sanction_Country_Report.xlsx');
   }
   else
   {
   this.commonService.errorsmsg("Unable to download excel,No data available in the table","Error"); 
   }
 }

/*
* Created By : Keerthana
* Description : This function will filter datatable according to search.
*********************************************/

filterBySearch()
{
  let searchCertificateNo = $("#searchCertificateNo").val().toString().toLowerCase();
  let searchPolicyNo = $("#searchPolicyNo").val().toString().toLowerCase();
  let searchBranchLocation = $("#searchBranchLocation").val().toString().toLowerCase();
  let searchInsuredName = $("#searchInsuredName").val().toString().toLowerCase();
  let searchProducerName = $("#searchProducerName").val().toString().toLowerCase();
  let searchVoyage = $("#searchVoyage").val().toString().toLowerCase();
  let searchModeOfShipment = $("#searchModeOfShipment").val().toString().toLowerCase();
  let searchFromCountry = $("#searchFromCountry").val().toString().toLowerCase();
  let searchToCountry = $("#searchToCountry").val().toString().toLowerCase();
  let searchFromCity = $("#searchFromCity").val().toString().toLowerCase();
  let searchToCity = $("#searchToCity").val().toString().toLowerCase();
  let searchTotalSumInsuredIn = $("#searchTotalSumInsuredIn").val().toString().toLowerCase();
  let searchSubjectMatterInsured = $("#searchSubjectMatterInsured").val().toString().toLowerCase();
  let searchExpectedDateOfShipment = $("#searchExpectedDateOfShipment").val().toString().toLowerCase();
  let searchActionBy = $("#searchActionBy").val().toString().toLowerCase();
  let searchReferredOn = $("#searchReferredOn").val().toString().toLowerCase();
  let searchActionOn = $("#searchActionOn").val().toString().toLowerCase();
 
  let table = $("#sanctionCountryReportDataTable").DataTable();
  table.search('').columns().search('').draw();
  if (searchCertificateNo != "") 
  {
    table.column(0).search(searchCertificateNo).draw();
  }
  if (searchPolicyNo != "")
  {
    table.column(1).search(searchPolicyNo).draw();
  }
  if (searchBranchLocation != "") 
  {
    table.column(2).search(searchBranchLocation).draw();
  }
  if (searchInsuredName != "") 
  {
    table.column(3).search(searchInsuredName).draw();
  }
  if (searchProducerName != "") 
  {
    table.column(4).search(searchProducerName).draw();
  }
  if (searchVoyage != "") 
  {
    table.column(5).search(searchVoyage).draw();
  }
  if (searchModeOfShipment != "")
  {
    table.column(6).search(searchModeOfShipment).draw();
  }
  if (searchFromCountry != "") 
  {
    table.column(7).search(searchFromCountry).draw();
  }
  if (searchToCountry != "") 
  {
    table.column(8).search(searchToCountry).draw();
  }
  if (searchFromCity != "") 
  {
    table.column(9).search(searchFromCity).draw();
  }
  if (searchToCity != "") 
  {
    table.column(10).search(searchToCity).draw();
  }
  if (searchTotalSumInsuredIn != "") 
  {
    table.column(11).search(searchTotalSumInsuredIn).draw();
  }
  if (searchSubjectMatterInsured != "") 
  {
    table.column(12).search(searchSubjectMatterInsured).draw();
  }
  if (searchExpectedDateOfShipment != "") 
  {
    table.column(13).search(searchExpectedDateOfShipment).draw();
  }
  if (searchActionBy != "") 
  {
    table.column(14).search(searchActionBy).draw();
  }
  if (searchReferredOn != "") 
  {
    table.column(15).search(searchReferredOn).draw();
  }
  if (searchActionOn != "") 
  {
    table.column(16).search(searchActionOn).draw();
  }
  
}


}
